<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Użytkownicy</span>
        <h3 class="page-title">Lista użytkowników</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button theme="success"
          @click.prevent="$router.push('/uzytkownicy/nowy')">
          <i class="material-icons">add</i>
          Dodaj użytkownika
        </d-button>
      </d-col>
    </d-row>
    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="users-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj imię, nazwisko lub e-mail użytkownika"
          v-model="filters.search" />
        <v-select
          style="width: 360px;"
          class="ml-2"
          :options="institutions"
          :reduce="institution => institution.id"
          v-model="filters.institution_id"
          placeholder="Lista poradni"
          :searchable="false"
          label="name">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <v-select
          style="width: 360px;"
          class="ml-2"
          :options="accountRoleOptions"
          v-model="filters.accountRole"
          placeholder="Rodzaj konta"
          :searchable="false"
          label="text">
        </v-select>
        <v-select
          style="width: 360px;"
          class="ml-2"
          :options="accountStatusUser"
          v-model="filters.account_status"
          placeholder="Status konta"
          :searchable="false"
          label="text">
        </v-select>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">Imię i nazwisko</th>
            <th scope="col" class="border-0">Status</th>
            <th scope="col" class="border-0">Adres e-mail</th>
            <th scope="col" class="border-0">Poradnia</th>
            <th scope="col" class="border-0">Rodzaj konta</th>
            <th scope="col" class="border-0">Przełożony</th>
            <th scope="col" class="border-0">Ostatnie logowanie</th>
            <th scope="col" class="border-0">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(user, index) of users"
            :key="'user-' + index">
            <td class="align-middle">
              {{ user.name }} {{ user.last_name }}
            </td>
            <td class="align-middle">
              <d-badge class="user-status" :theme="user.account_status === 'S_CONFIRMED' ? 'success' : (user.account_status === 'S_BLOCKED' ? 'danger' : 'primary')">
                {{user.account_status === 'S_CONFIRMED' ? 'Zatwierdzony' : (user.account_status === 'S_BLOCKED' ? 'Zablokowany' : 'Nowy') }}
              </d-badge>
            </td>
            <td class="align-middle rwd-user" style="font-weight: 100">
              {{ user.email }}
            </td>
            <td class="align-middle" style="max-width: 15rem">
                <span
                  v-for="(institution, index) in user.institutions" :key="index">
                  {{institution.name + ', '}}
                </span>
            </td>
            <td class="align-middle">
              <strong
                v-if="user.role === 'R_ADMIN'"
                class="font-weight-bold"
                style="color: #17c671"
              >
                Administrator
              </strong>
              <span
                v-if="user.role === 'R_USER'">
                Użytkownik
              </span>
              <span
                v-if="user.role === 'R_HR'">
                Kadrowy/a
              </span>
              <span
                v-if="user.role === 'R_RECEPTION'"
                style="color: #007bff">
                Recepcja
              </span>
            </td>
            <td class="align-middle">
              <div v-for="(boss, index) in bosses" :key="index">
                {{ user.parent_id === boss.id ? (boss.name + ' ' + boss.last_name) : '' }}
              </div>
            </td>
            <td class="align-middle" v-if="user.last_login_date">
              <span style="white-space: nowrap;">{{ user.last_login_date.slice(0, 10) }}</span>
              <span style="display: block; color: #17c671">{{ user.last_login_date.slice(10) }}</span>
            </td>
            <td class="align-middle" v-else>
              <span style="opacity: 0.5">Brak</span>
            </td>
            <td
              class="align-middle"
              style="width: 150px; display: flex">
              <d-button
                theme="primary"
                @click.prevent="$router.push('/uzytkownicy/edycja/' + user.id)"
                class="mr-2"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="users.length === 0">
            <td
              colspan="8"
              class="text-center">
              Brak użytkowników do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../utils/FormUtils.js';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';

export default {
  name: 'users',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  computed: {
    accountData () {
      return this.$store.getters.getAccount
    },
    accountRoleOptions () {
      return [
        {
          text: 'Dowolny',
          value: ''
        },
        {
          text: 'Administrator',
          value: 'R_ADMIN'
        },
        {
          text: 'Użytkownik',
          value: 'R_USER'
        },
        {
          text: 'Kadrowy/a',
          value: 'R_HR'
        },
        {
          text: 'Recepcja',
          value: 'R_RECEPTION'
        }
      ];
    },
    accountStatusUser () {
      return [
        {
          text: 'Nowy',
          value: 'S_NEW'
        },
        {
          text: 'Zablokowany',
          value: 'S_BLOCKED'
        },
        {
          text: 'Zaakceptowany',
          value: 'S_CONFIRMED'
        }
      ];
    },
  },
  data() {
    return {
      institutions: [],
      users: [],
      bosses: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      filters: {
        search: '',
        accountRole: '',
        institution_id: '',
        account_status: ''
      }
    };
  },
  mounted () {
    this.loadFilteredData();
    this.getBossList();
    this.getAccount();
    this.loadInstitutionsListData();
  },
  methods: {
    getAccount () {
      this.$store.dispatch('userAccountGet')
    },
    loadInstitutionsListData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: 'institutions/items',
        outputKey: 'institutions',
      });
    },
    getBossList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/bosses',
        outputKey: 'bosses',
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        search: this.filters.search
      };

      if (this.filters.accountRole !== null && this.filters.accountRole && this.filters.accountRole.value) {
        where.role = this.filters.accountRole.value;
      }
      if (this.filters.institution_id !== null && this.filters.institution_id) {
        where.institution_id = this.filters.institution_id;
      }
      if (this.filters.account_status !== null && this.filters.account_status) {
        where.account_status = this.filters.account_status.value;
      }

      ListUtils.loadItemsData(this, {
        endpoint: '/users/items?page=' + this.currentPage,
        listField: 'users',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: '',
        accountRole: ''
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['users-filters-form'], this.debouncedLoadFilteredData);
    },
    removeUser (userID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/users/delete/',
        id: userID,
        successTitle: 'Usunięto użytkownika',
        successText: 'Wybrany użytkownik został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć tego użytkownika?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie użytkownika nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
  .user-status {
    display: block !important;
    border-radius: 40px;
    font-size: 12px !important;
    padding: 7px 5px !important;
  }
  .rwd-user {
    @media only screen and (max-width: 1370px) {
      max-width: 10rem !important;
    }
  }
</style>

